import { accountReducers } from './account.reducer';
import { accountApplicationReducers } from './accountApplication.reducer';
import accountDetails from './accountDetails';
import { accountHolderReducers } from './accountHolders.reducers';
import app from './app';
import { auth } from './auth';
import cashiering from './cashiering';
import configs from './configs';
import investigations from './investigations';
import { offerOrderReducers } from './offerOrder.reducer';
import offers from './offers.reducers';
import offerWatches from './offerWatches.reducers';
import { orderReducers } from './order.reducer';
import { positionReducers } from './position.reducer';
import { quoteReducers } from './quote.reducer';
import { statementReducers } from './statement.reducer';
import toastMessages from './toastMessages';
import user from './users.reducers';

const reducer = {
  auth,
  user,
  accountDetails,
  accounts: accountReducers,
  accountHolders: accountHolderReducers,
  accountApplications: accountApplicationReducers,
  statements: statementReducers,
  cashiering,
  offers,
  offerWatches,
  investigations,
  configs,
  orders: orderReducers,
  positions: positionReducers,
  quotes: quoteReducers,
  offerOrders: offerOrderReducers,
  toastMessages,
  app,
};

export default reducer;
